import {DachCountryCodes} from '../domain/languages';
import {DACH_COUNTRY_CODES} from '../lib/constants';
import {SupportedLanguages} from '../types/SupportedLanguages';

import {safelyUseLanguageProfile} from './safelyUseLanguageProfile';

export const getDachCountryNameFromCode = (code: DachCountryCodes, lang: SupportedLanguages): string => {
  const langKeys = DACH_COUNTRY_CODES.find((entry) => entry.id === code)?.label;

  return safelyUseLanguageProfile(lang, langKeys) || '';
};
